import { GlobalFilterType } from '@app/core/models/common.models';
import { StateToken } from '@ngxs/store';

export interface GlobalFilterDefaults {
  accountsDefaultFilter: string;
  PGDefaultFilter: string;
  campaignsDefaultFilter: string;
  adGroupsDefaultFilter: string;
  criteriaDefaultFilter: string;
}

export const GLOBAL_FILTERS_STATE_TOKEN = new StateToken<GlobalFiltersStateModel>('globalFilters');

export interface GlobalFiltersStateModel {
  errors?: {
    notFoundError?: GlobalFilterType;
  };
  filterDefaults: GlobalFilterDefaults;
}
